import { PORTAL_PROXY_BASE_URL } from '../settings';

export const createPortalBaseUrl = (url: string): string => {
  if (url === '' || url === undefined) {
    return url;
  }

  // get first part of fqdn only
  const hostname = url.replace(/^(https?:\/\/)?([^./]+).*$/, '$2');
  if (hostname === '' || (hostname === url && url.includes('.'))) {
    throw new Error('Cannot obtain portal base url.');
  }

  // url slug should be like this: /servicedesk/customer/portal/1
  const slug = url.replace(/^(https?:\/\/)?[^/]+(\/.*)$/, '$2');
  if (slug === '' || !slug.match(/^\/servicedesk\/customer\/portal\/(\d+).*$/)) {
    throw new Error('Cannot obtain portal base url.');
  }
  const portalId = slug.replace(/^\/servicedesk\/customer\/portal\/(\d+).*$/, '$1');

  return `${PORTAL_PROXY_BASE_URL}${hostname}/rest/servicedesk/1/customer/portal/${portalId}`;
};
